import React, { useState } from "react";
import "./Logisticsclientlanding.css";
import Logisticssubscribedclients from './Logisticssubscribedclients';
import Logisticspaidclients from './Logisticspaidclients';


const TabsLayout = () => {
  const [activeTab, setActiveTab] = useState("Registration");



  const renderComponent = () => {
    switch (activeTab) {
      case "Registration":
        return <Logisticspaidclients />;
      case "Subscribed":
        return <Logisticssubscribedclients />;
      //   case "Summery":
      //     return <Foodsubscribedclients title="Summery" />;

      default:
        return <Logisticspaidclients />;
    }
  };

  const tabs = [
    "Registration",
    "Subscribed",

  ];

  return (
    <div className="tabs-wrapper">
      {/* TOP ONE-ROW TABS (ALL SCREENS) */}
      <div className="tabs-row">
        {tabs.map((tab) => (
          <span
            key={tab}
            className={`row-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </span>
        ))}
      </div>

      {/* CONTENT */}
      <div className="tabs-content">
        {renderComponent()}
      </div>
    </div>
  );
};

export default TabsLayout;

